import { required, ValidationRules } from '@leaflink/stash/useValidation';

import { ShareEmailMenuFormState, ShareMenuOptionsState } from '@/models/shop';

export function getInitialShareMenuOptionsState(): ShareMenuOptionsState {
  return {
    licenseType: null,
    defaultMenu: {
      productQuantities: true,
      productImages: true,
      internalProducts: false,
    },
    orderForm: {
      brandLogo: true,
      brandTaglineDescription: true,
      contactInfo: true,
      productImages: true,
      productQuantities: true,
    },
  };
}

export function getInitialEmailMenuShareState(): ShareEmailMenuFormState {
  return {
    selectedRecipients: [],
    message: '',
  };
}

export function getEmailMenuShareValidationRules(): ValidationRules<ShareEmailMenuFormState> {
  return {
    selectedRecipients: [required()],
    message: [required()],
  };
}

export function getShareMenuOptionsValidationRules({
  isDownloadOptionSelected,
}: {
  isDownloadOptionSelected: boolean;
}): ValidationRules<Partial<ShareMenuOptionsState>> {
  return {
    licenseType: isDownloadOptionSelected ? [] : [required()],
  };
}
